export default "__VITE_ASSET__e27f69fa__"